// extracted by css-extract-rspack-plugin
export default {"cls1":"CoScientistPricingPage-cls1_d33","cls2":"CoScientistPricingPage-cls2_Qxs CoScientistPricingPage-cls1_d33"};